const STALE_CHUNK_RELOAD_KEY = 'overhear:stale-chunk-reload';

/** True when a dynamic import failed because the deployed chunk no longer exists. */
export function isStaleLazyChunkError(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : String(reason ?? '');

  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Failed to load module script/i.test(message) ||
    (/MIME type/i.test(message) && /module script/i.test(message))
  );
}

/** Reload once per session so a fresh index.html and chunk manifest are fetched after deploy. */
export function reloadForStaleLazyChunks(): void {
  try {
    if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) === '1') {
      return;
    }
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1');
  } catch {
    // sessionStorage blocked — still try a single reload
  }
  window.location.reload();
}

export function clearStaleLazyChunkReloadFlag(): void {
  try {
    sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }
}

/**
 * After a deploy, long-lived tabs may still reference old hashed chunks. Missing
 * chunks are rewritten to index.html on Hosting, which triggers MIME errors on import.
 */
export function registerStaleLazyChunkRecovery(): void {
  if (typeof window === 'undefined') return;

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadForStaleLazyChunks();
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isStaleLazyChunkError(event.reason)) return;
    event.preventDefault();
    reloadForStaleLazyChunks();
  });
}
